import { useState, useEffect, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { getRights } from "../../redux/actions/userRights.action";
import { loadCountry } from "../../redux/actions/adminCountry";
import { loadState } from "../../redux/actions/adminState";
import { loadCity } from "../../redux/actions/adminCity";

import Tables from "../../components/Table/Tables";
import { Button, Form, Input, Modal, Select, Switch, Tooltip, Popconfirm } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, FilterFilled, SearchOutlined } from "@ant-design/icons";
import { ReadCookie } from "../../utils/readCookie";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { getOneCustomerAddress } from "../../redux/actions/customerAddress.action";
import filterHelper from "../../utils/filterHelper";
import Swal from "sweetalert2";

const { Option } = Select;

export default function BillingSection({ customer_id, token, formType, billingAddress, setBillingAddress, deletedBillingLine, setDeletedBillingLine, menuId }) {
  const { Billing, City, State, country } = useSelector((state) => state);
  const [eventType, setEventType] = useState("");
  const [countryForm, setCountry] = useState({});
  const [visible, setVisible] = useState(false);
  const [stateForm, setState] = useState({});
  const [cityForm, setCity] = useState({});
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [customerAddId, setCustomerAddId] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const billingColumns = [
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      ...filterHelper("first_name")
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      ...filterHelper("last_name")
    },
    {
      title: "Addressee",
      dataIndex: "address_addressee",
      key: "address_addressee",
      ...filterHelper("address_addressee")
    },
    {
      title: "Address 1",
      dataIndex: "address_address_1",
      key: "address_address_1",
      ...filterHelper("address_address_1")
    },
    {
      title: "Address 2",
      dataIndex: "address_address_2",
      key: "address_address_2",
      ...filterHelper("address_address_2")
    },
    {
      title: "City",
      dataIndex: "address_city_name",
      key: "address_city_name",
      ...filterHelper("address_city_name")
    },
    {
      title: "State",
      dataIndex: "address_state_name",
      key: "address_state_name",
      ...filterHelper("address_state_name")
    },
    {
      title: "Zip",
      dataIndex: "address_zip_code",
      key: "address_zip_code",
      ...filterHelper("address_zip_code")
    },
    {
      title: "Country",
      dataIndex: "address_country_name",
      key: "address_country_name",
      ...filterHelper("address_country_name")
    },
    {
      title: "Active",
      key: "action",
      render: (text, record) => {
        return (
          <>
            {record.is_active === false ? "False" : "True"}
          </>
        )
      }
    },
    {
      title: "Default Billing",
      key: "action",
      render: (text, record) => {
        return (
          <>
            {record.default_bill_to === false ? "False" : "True"}
          </>
        )
      }
    },
    {
      title: "Default Shipping",
      key: "action",
      render: (text, record) => (
        <>
          {record.default_ship_to === false ? "False" : "True"}
        </>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record, index) => {
        return (
          <>
            {
              formType !== "formView" && (
                <>
                  <Tooltip title="Edit" color={"white"}>
                    <EditOutlined
                      className={`edit-Button`}
                      onClick={() => hanldeSubItems(record, index)}
                    />
                  </Tooltip>
                  <Tooltip title="Delete" color={"white"}>
                    <Popconfirm
                      title={`Are you sure to delete?`}
                      onConfirm={() => hanldeDeleteItems(record, billingAddress.findIndex((v) => v.customer_address_id === record.customer_address_id))}
                    >
                      <DeleteOutlined className={`delete-Button`} />
                    </Popconfirm>
                  </Tooltip>
                </>
              )
            }
          </>
        )
      },
    }
  ];

  useLayoutEffect(() => {
    dispatch(getRights(token, menuId))
  }, []);

  useEffect(() => {
    if (formType === "add") {
      return setBillingAddress([]);
    }
    if (customer_id !== "" && formType === "formView") {
      setTimeout(() => {
        dispatch(getOneCustomerAddress(token, customer_id)).then((res) => {
          setBillingAddress(res?.payload?.data);
        });
      }, 2000);
    }
  }, [customer_id]);

  const hanldeSubItems = (record, index) => {
    dispatch(loadCountry(token));
    setEventType("edit");
    setVisible(true);
    if (typeof record.customer_address_id === 'number') {
      setCustomerAddId(record.customer_address_id)
    } else {
      setSelectedIndex(record.index)
    }
    form.setFieldsValue({
      addressee: record.address_addressee,
      address_1: record.address_address_1,
      address_2: record.address_address_2,
      address_3: record.address_3,
      email: record.address_email,
      fax: record.address_fax,
      phone: record.address_phone,
      zip_code: record.address_zip_code,
      city: parseInt(record.address_city_id),
      state: parseInt(record.address_state_id),
      country: parseInt(record.address_country_id),
      isActive: record.is_active === false ? false : true, // due to records contain is_active null, so only false if its actual value is false
      fname: record.first_name,
      lname: record.last_name,
      defaultBillTo: record.default_bill_to === false ? false : true,
      defaultShipTo: record.default_ship_to === false ? false : true,
    });
    dispatch(loadCity(token, record.address_country_id));
    dispatch(loadState(token, record.address_country_id));
  };

 const hanldeDeleteItems = (record, index) => {
    let checkBilling_Shipping = false;

    if (record.default_bill_to || record.default_ship_to) {
      checkBilling_Shipping = false;
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Default ${record.default_bill_to && record.default_ship_to ? "Billing and Shipping addresses" : record.default_bill_to ? "Billing address" : "Shipping address"} cannot be deleted.`,
      });
      return;
    } else {
      checkBilling_Shipping = true;
    }

    if (checkBilling_Shipping) {
      const dataSource = [...billingAddress];
      const deleteDataSource = [...deletedBillingLine];
      record.default_bill_to = false;
      record.default_ship_to = false;
      deleteDataSource.push(record);
      setDeletedBillingLine(deleteDataSource)
      setBillingAddress(dataSource.filter((item, i) => i !== index));
    }

  };

  const onChangeCountry = (value, obj) => {
    setCountry(obj);
    dispatch(loadCity(token, `${value}`));
    dispatch(loadState(token, `${value}`));
  };

  const onChangeCity = (value, obj) => {
    setCity(obj);
  };

  const onChangeState = (value, obj) => {
    setState(obj);
  };

  const onSearch = (val) => { };

  const handleOk = async (data) => {
    const addresses = [...billingAddress]
    if (eventType === "add") {
      await form.validateFields().then((values) => {
        if (values.defaultBillTo) {
          addresses.map((v) => {
            if (v.default_bill_to) {
              v.default_bill_to = false
              v.is_edited = true
            }
          });
        }
        if (values.defaultShipTo) {
          addresses.map((v) => {
            if (v.default_ship_to) {
              v.default_ship_to = false
              v.is_edited = true
            }
          });
        }
        const data = {
          address_addressee: values.addressee,
          customer_full_address: `${values.address_1 !== null ? values.address_1 : null} ${values.address_2 !== null ? values.address_2 : null}`,
          address_address_1: values.address_1,
          address_address_2: values.address_2,
          address_address_3: null,
          first_name: values.fname,
          last_name: values.lname,
          address_country_id: values.country,
          address_country_name: countryForm.children,
          address_state_id: values.state,
          address_state_name: stateForm.children,
          address_city_id: values.city,
          address_city_name: cityForm.children,
          address_email: values.email,
          address_phone: values.phone,
          address_fax: values.fax,
          address_zip_code: values.zip_code,
          is_active: values.isActive,
          default_bill_to: values.defaultBillTo,
          default_ship_to: values.defaultShipTo,
          customer_id: customer_id,
          is_edited: true,
          index: addresses.length
        };
        setBillingAddress([...addresses, data]);
        form.setFieldsValue({
          first_name: null,
          last_name: null,
          address_addressee: null,
          address_address_1: null,
          address_address_2: null,
          address_country_name: null,
          address_city_name: null,
          address_state_name: null,
          email: null,
          fax: null,
          phone: null,
          address_zip_code: null,
          is_active: null,
          default_bill_to: null,
          default_ship_to: null,
        })
        setVisible(false);
      });
    } else if (eventType === "edit") {
      await form.validateFields().then((values) => {
        const selectedItemIndex = customerAddId ? addresses.findIndex(x => x.customer_address_id === customerAddId) : selectedIndex
        const findCountry = country?.payload?.data.find((v) => v.country_id === values.country)
        const findCity = City?.payload?.data.find((v) => v.city_id === values.city)
        const findState = State?.payload?.data.find((v) => v.state_id === values.state)
        if (values.defaultBillTo) {
          addresses.map((v) => {
            if (v.default_bill_to) {
              v.default_bill_to = false
              v.is_edited = true
            }
          });
        }
        if (values.defaultShipTo) {
          addresses.map((v) => {
            if (v.default_ship_to) {
              v.default_ship_to = false
              v.is_edited = true
            }
          });
        }
        if (typeof selectedItemIndex === 'number') {
          addresses[selectedItemIndex].first_name = values.fname;
          addresses[selectedItemIndex].last_name = values.lname;
          addresses[selectedItemIndex].address_addressee = values.addressee;
          addresses[selectedItemIndex].address_address_1 = values.address_1;
          addresses[selectedItemIndex].address_address_2 = values.address_2;
          addresses[selectedItemIndex].address_country_id = values?.country;
          addresses[selectedItemIndex].address_state_id = values?.state;
          addresses[selectedItemIndex].address_city_id = values?.city;
          addresses[selectedItemIndex].address_country_name = findCountry?.country_name;
          addresses[selectedItemIndex].address_state_name = findState?.state_name;
          addresses[selectedItemIndex].address_city_name = findCity?.city_name;
          addresses[selectedItemIndex].address_email = values.email;
          addresses[selectedItemIndex].address_phone = values.phone;
          addresses[selectedItemIndex].address_fax = values.fax;
          addresses[selectedItemIndex].address_zip_code = values.zip_code;
          addresses[selectedItemIndex].is_active = values.isActive;
          addresses[selectedItemIndex].default_bill_to = values.defaultBillTo;
          addresses[selectedItemIndex].default_ship_to = values.defaultShipTo;
          addresses[selectedItemIndex].is_edited = true;
        }
        setCustomerAddId(null)
        setSelectedIndex(null)
        setBillingAddress([...addresses])
        setVisible(false);
      });

    }
  };

  const handleCancel = () => {
    setVisible(false);
    setCustomerAddId(null)
    setSelectedIndex(null)
    form.setFieldsValue({
      addressee: null,
      address_1: null,
      address_2: null,
      address_3: null,
      email: null,
      fax: null,
      phone: null,
      zip_code: null,
      city: null,
      state: null,
      country: null,
      isActive: true,
      fname: null,
      lname: null,
      defaultBillTo: false,
      defaultShipTo: false,
    });
  };

  const getModalData = () => {
    dispatch(loadCountry(token));
    form.setFieldsValue({
      addressee: null,
      address_1: null,
      address_2: null,
      address_3: null,
      email: null,
      fax: null,
      phone: null,
      zip_code: null,
      city: null,
      state: null,
      country: null,
      isActive: true,
      fname: null,
      lname: null,
      defaultBillTo: false,
      defaultShipTo: false,
    });
    setEventType("add");
    setVisible(true);
  };
  return (
    <>
      <div>
        <Modal
          className="modal-40"
          visible={visible}
          title="Address Form"
          okText="Submit"
          onOk={(data) => handleOk(data)}
          onCancel={handleCancel}
        >
          <Form
            form={form}
            layout="vertical"
            name="form_in_modal"
            initialValues={{ modifier: "public" }}
          >
            <div className="container-fluid p-0 modal-form-main">
              <Brow>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="fname" label=" First Name ">
                    <Input
                      size="small"
                      className="b-radius-10"
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item
                    name="lname"
                    label="Last Name "
                  >
                    <Input
                      size="small"
                      className="b-radius-10"
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item
                    name="addressee"
                    label="Addressee"
                    rules={[
                      { message: "Addressee is required", required: true },
                    ]}
                  >
                    <Input
                      size="small"
                      className="b-radius-10"
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="address_1" label="Address 1">
                    <Input
                      size="small"
                      className="b-radius-10"
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="address_2" label="Address 2">
                    <Input
                      size="small"
                      className="b-radius-10"
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="country" label="Country"
                    rules={[
                      {
                        required: true,
                        message: "Country is required",
                      },
                    ]}
                  >
                    <Select
                      size="small"
                      showSearch
                      optionFilterProp="children"
                      value={
                        formType === "edit"
                          ? form.getFieldValue().country
                          : null
                      }
                      onChange={onChangeCountry}
                      onSearch={onSearch}
                      loading={country.loading}
                    >
                      {country?.payload?.data &&
                        country?.payload?.data.map((country) => {
                          return (
                            <Option
                              key={country.country_id}
                              value={country.country_id}
                            >
                              {country.country_name}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="city" label="City"
                    rules={[
                      {
                        required: true,
                        message: "City is required",
                      },
                    ]}
                  >
                    <Select
                      size="small"
                      showSearch
                      optionFilterProp="children"
                      value={cityForm}
                      onChange={onChangeCity}
                      onSearch={onSearch}
                      loading={City.loading}
                      defaultValue={
                        formType === "edit" ? form.getFieldValue().city : null
                      }
                    >
                      {City?.payload?.data &&
                        City?.payload?.data.map((city) => (
                          <Option key={city.city_id} value={city.city_id}>
                            {city.city_name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="state" label="State"
                    rules={[
                      {
                        required: true,
                        message: "State is required",
                      },
                    ]}
                  >
                    <Select
                      size="small"
                      showSearch
                      optionFilterProp="children"
                      value={stateForm}
                      onChange={onChangeState}
                      onSearch={onSearch}
                      loading={State.loading}
                    >
                      {State?.payload?.data &&
                        State?.payload?.data.map((state) => (
                          <Option key={state.state_id} value={state.state_id}>
                            {state.state_name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      {
                        type: "email",
                        message: "The input is not valid E-mail!",
                      },
                    ]}
                  >
                    <Input
                      size="small"
                      className="b-radius-10"
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="fax" label="Fax">
                    <Input
                      size="small"
                      className="b-radius-10"
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item
                    name="phone"
                    label="Phone"
                  >
                    <Input
                      size="small"
                      className="b-radius-10"
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item
                    name="zip_code"
                    label="Zip"
                  >
                    <Input
                      size="small"
                      className="b-radius-10"
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={3} xl={3} xxl={3}>
                  <Form.Item label="Active" name="isActive">
                    <Switch
                      size="small"
                      key={form.getFieldValue().isActive}
                      defaultChecked={form.getFieldValue().isActive}
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={3} xl={3} xxl={3}>
                  <Form.Item label="Default Billing" name="defaultBillTo">
                    <Switch
                      size="small"
                      key={form.getFieldValue().defaultBillTo}
                      defaultChecked={form.getFieldValue().defaultBillTo}
                    />
                  </Form.Item>
                </Bcol>
                <Bcol lg={3} xl={3} xxl={3}>
                  <Form.Item label="Default shipping" name="defaultShipTo">
                    <Switch
                      size="small"
                      key={form.getFieldValue().defaultShipTo}
                      defaultChecked={form.getFieldValue().defaultShipTo}
                    />
                  </Form.Item>
                </Bcol>
              </Brow>
            </div>
          </Form>
        </Modal>
      </div>
      <Button
        disabled={!(formType === "add" || formType === "edit")}
        className="iconBtn crudBTN float-right mbpx-5"
        shape="circle"
        icon={<PlusOutlined />}
        onClick={() => getModalData()}
      />

      <Tables
        type="billing"
        billingObj={() => { }}
        scroll={520}
        perPage={5}
        scrollX={"90rem"}
        source={JSON.parse(JSON.stringify(billingAddress.sort((a, b) => {
          if (a.default_bill_to === b.default_bill_to) {
            return a.default_ship_to === b.default_ship_to ? 0 : a.default_ship_to ? -1 : 1;
          } else {
            return a.default_bill_to ? -1 : 1;
          }
        })))}
        col={billingColumns}
        load={Billing.loading}
        paginate
      />
    </>
  );
}
